import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=22d7f4d2&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=22d7f4d2&prod&lang=css"
import style1 from "./ProductsList.vue?vue&type=style&index=1&id=22d7f4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7f4d2",
  null
  
)

export default component.exports